import { IconProps } from "./types";
import React from "react";

export const CaretIcon = ({
  className,
  fill = "currentColor",
  width = 14,
  height = 14,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 14 14"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M3.0625 5.02881L7 8.96631L10.9375 5.02881"
      stroke={fill}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);
